// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__5NNvB","searchbar":"SearchBar_searchbar__jbjwo","btn-clear":"SearchBar_btn-clear__2H3iB"};